import React from 'react';
import { Target, Eye, Gem, Users } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { useTranslation } from 'react-i18next';

const MissionVision = () => {
  const { t } = useTranslation();

  return (
    <section 
      id="mission" 
      className="py-20 bg-white"
      aria-label="Seção sobre missão, visão e valores"
    >
      <div className="container mx-auto px-4">
        {/* Mission & Vision */}
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {/* Mission */}
          <Card 
            className="border-2 border-teal-100 hover:border-teal-300 transition-all duration-300"
            role="article"
            aria-label={t('mission.title')}
          >
            <CardContent className="p-8">
              <div 
                className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6"
                aria-hidden="true"
              >
                <Target className="text-teal-600" size={32} />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {t('mission.title')}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {t('mission.description')}
              </p>
            </CardContent>
          </Card>

          {/* Vision */}
          <Card 
            className="border-2 border-blue-100 hover:border-blue-300 transition-all duration-300"
            role="article"
            aria-label={t('mission.visionTitle')}
          >
            <CardContent className="p-8">
              <div 
                className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6"
                aria-hidden="true"
              >
                <Eye className="text-blue-600" size={32} />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {t('mission.visionTitle')}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {t('mission.visionDescription')}
              </p>
            </CardContent>
          </Card>
        </div>

        {/* Values */}
        <div className="text-center mb-12">
          <div 
            className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-teal-500 to-blue-600 rounded-full mb-4"
            aria-hidden="true"
          >
            <Gem className="text-white" size={32} />
          </div>
          <h3 className="text-3xl font-bold text-gray-900 mb-4">{t('mission.valuesTitle')}</h3>
          <p className="text-gray-600 max-w-2xl mx-auto">
            {t('mission.valuesSubtitle')}
          </p>
        </div>

        <div 
          className="grid md:grid-cols-2 lg:grid-cols-4 gap-6"
          role="list"
          aria-label="Lista de valores organizacionais"
        >
          <Card className="border border-gray-200 hover:shadow-lg transition-all duration-300" role="listitem">
            <CardContent className="p-6 text-center">
              <div 
                className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4"
                aria-hidden="true"
              >
                <Users className="text-teal-600" size={24} />
              </div>
              <h4 className="font-bold text-gray-900 mb-2">{t('mission.values.diversity.title')}</h4>
              <p className="text-sm text-gray-600">{t('mission.values.diversity.description')}</p>
            </CardContent>
          </Card>
          
          <Card className="border border-gray-200 hover:shadow-lg transition-all duration-300" role="listitem">
            <CardContent className="p-6 text-center">
              <div 
                className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4"
                aria-hidden="true"
              >
                <Users className="text-teal-600" size={24} />
              </div>
              <h4 className="font-bold text-gray-900 mb-2">{t('mission.values.innovation.title')}</h4>
              <p className="text-sm text-gray-600">{t('mission.values.innovation.description')}</p>
            </CardContent>
          </Card>
          
          <Card className="border border-gray-200 hover:shadow-lg transition-all duration-300" role="listitem">
            <CardContent className="p-6 text-center">
              <div 
                className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4"
                aria-hidden="true"
              >
                <Users className="text-teal-600" size={24} />
              </div>
              <h4 className="font-bold text-gray-900 mb-2">{t('mission.values.transparency.title')}</h4>
              <p className="text-sm text-gray-600">{t('mission.values.transparency.description')}</p>
            </CardContent>
          </Card>
          
          <Card className="border border-gray-200 hover:shadow-lg transition-all duration-300" role="listitem">
            <CardContent className="p-6 text-center">
              <div 
                className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4"
                aria-hidden="true"
              >
                <Users className="text-teal-600" size={24} />
              </div>
              <h4 className="font-bold text-gray-900 mb-2">{t('mission.values.commitment.title')}</h4>
              <p className="text-sm text-gray-600">{t('mission.values.commitment.description')}</p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default MissionVision;
